"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _IconButton = require("./IconButton");

var _Icon = _interopRequireDefault(require("../Icon/Icon"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var IconToggleButton = function IconToggleButton(_ref) {
  var icon = _ref.icon,
      toggledIcon = _ref.toggledIcon,
      onClick = _ref.onClick;

  var _useState = (0, _react.useState)(false),
      isToggled = _useState[0],
      setIsToggled = _useState[1];

  var handleToggle = function handleToggle() {
    setIsToggled(!isToggled);
    onClick();
  };

  var getIconName = function getIconName() {
    return isToggled ? toggledIcon : icon;
  };

  return /*#__PURE__*/_react["default"].createElement(_IconButton.CircleButton, {
    onClick: handleToggle,
    size: 48
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    name: getIconName()
  }));
};

IconToggleButton.propTypes = {
  onClick: _propTypes["default"].func.isRequired,
  icon: _propTypes["default"].string.isRequired,
  toggledIcon: _propTypes["default"].string.isRequired
};
var _default = IconToggleButton;
exports["default"] = _default;